
import React from 'react';
import { TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Newspaper, RssIcon, Tag, Calendar, TrendingUp, Bookmark } from 'lucide-react';

interface NewsTabNavigationProps {
  activeTab: string;
}

const NewsTabNavigation: React.FC<NewsTabNavigationProps> = ({ activeTab }) => {
  return (
    <TabsList className="grid grid-cols-3 md:grid-cols-6 w-full h-auto p-1">
      <TabsTrigger value="all" className="text-xs md:text-sm">
        <Newspaper className="h-4 w-4 mr-1 md:mr-2" />
        <span className="hidden md:inline">All News</span>
        <span className="md:hidden">All</span>
      </TabsTrigger>
      <TabsTrigger value="business" className="text-xs md:text-sm">
        <RssIcon className="h-4 w-4 mr-1 md:mr-2" />
        <span className="hidden md:inline">Business</span>
        <span className="md:hidden">Business</span>
      </TabsTrigger>
      <TabsTrigger value="technology" className="text-xs md:text-sm">
        <Tag className="h-4 w-4 mr-1 md:mr-2" />
        <span className="hidden md:inline">Technology</span>
        <span className="md:hidden">Tech</span>
      </TabsTrigger>
      <TabsTrigger value="industry" className="text-xs md:text-sm">
        <Calendar className="h-4 w-4 mr-1 md:mr-2" />
        <span className="hidden md:inline">Industry</span>
        <span className="md:hidden">Industry</span>
      </TabsTrigger>
      <TabsTrigger value="trending" className="text-xs md:text-sm">
        <TrendingUp className="h-4 w-4 mr-1 md:mr-2" />
        <span className="hidden md:inline">Trending</span>
        <span className="md:hidden">Trending</span>
      </TabsTrigger>
      <TabsTrigger value="saved" className="text-xs md:text-sm">
        <Bookmark className="h-4 w-4 mr-1 md:mr-2" />
        <span className="hidden md:inline">Saved</span>
        <span className="md:hidden">Saved</span>
      </TabsTrigger>
    </TabsList>
  );
};

export default NewsTabNavigation;
